module.exports = __webpack_public_path__ + "img/Shakieroen Baghas.be5a9f78.png";